module.exports = __webpack_public_path__ + "static/media/family.ff850f73.png";